(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[967],{

/***/ 799:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/stock-prices-table",
      function () {
        return __webpack_require__(4717);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RM": function() { return /* binding */ TableBody; },
/* harmony export */   "SC": function() { return /* binding */ TableRow; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "pj": function() { return /* binding */ TableCell; },
/* harmony export */   "xD": function() { return /* binding */ TableHeader; },
/* harmony export */   "xs": function() { return /* binding */ TableHeaderCell; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Table_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9838);
/* harmony import */ var _Table_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Table_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Utilities_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3555);
/* harmony import */ var _Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3__);




const Table = (param)=>/*#__PURE__*/ {
    let { children , className , style  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("table", {
        className: "".concat((_Table_module_css__WEBPACK_IMPORTED_MODULE_2___default().table), " ").concat(className),
        style: style,
        children: children
    });
};
const TableRow = (param)=>/*#__PURE__*/ {
    let { children , style  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
        className: (_Table_module_css__WEBPACK_IMPORTED_MODULE_2___default().tableRow),
        style: style,
        children: children
    });
};
const TableHeader = (param)=>/*#__PURE__*/ {
    let { children , style  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
        className: (_Table_module_css__WEBPACK_IMPORTED_MODULE_2___default().tableHeader),
        style: style,
        children: children
    });
};
const TableBody = (param)=>/*#__PURE__*/ {
    let { children , style  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
        className: (_Table_module_css__WEBPACK_IMPORTED_MODULE_2___default().tableBody),
        style: style,
        children: children
    });
};
const TableHeaderCell = (param)=>{
    let { children , className , style , align ="left" , hideOnMobile  } = param;
    let computedClasses = className !== null && className !== void 0 ? className : "";
    // Alignment
    computedClasses += align === "right" ? " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().alignRight)) : " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().alignLeft));
    // Hide on mobile
    computedClasses += hideOnMobile ? " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().hide)) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
        className: computedClasses,
        style: style,
        children: children
    });
};
const TableCell = (param)=>{
    let { children , className , style , align ="left" , numberType , hideOnMobile , shortenOnMobile =false  } = param;
    let computedClasses = className !== null && className !== void 0 ? className : "";
    // Alignment
    if (align === "right") {
        computedClasses += " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().alignRight));
    } else {
        computedClasses += " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().alignLeft));
    }
    // Text color
    if (numberType) {
        computedClasses += " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default())[numberType]);
    }
    // Hide on mobile
    if (hideOnMobile) {
        computedClasses += " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().hide));
    }
    // Ellipsis for long text
    if (shortenOnMobile) {
        computedClasses += " ".concat((_Utilities_module_css__WEBPACK_IMPORTED_MODULE_3___default().ellipsis));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
        className: computedClasses,
        style: style,
        children: children
    });
};



/***/ }),

/***/ 944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const Arrow = (param)=>/*#__PURE__*/ {
    let { rotation =0  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24px",
        height: "24px",
        focusable: "false",
        "aria-hidden": "true",
        viewBox: "0 0 24 24",
        style: {
            transform: "rotate(".concat(rotation, "deg)")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "var(--arrowColor)",
            d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Arrow);


/***/ }),

/***/ 9406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _TrendArrow_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8682);
/* harmony import */ var _TrendArrow_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_TrendArrow_module_css__WEBPACK_IMPORTED_MODULE_2__);



const TrendArrow = (param)=>/*#__PURE__*/ {
    let { positive  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: "".concat((_TrendArrow_module_css__WEBPACK_IMPORTED_MODULE_2___default().itemArrow), " ").concat(positive ? (_TrendArrow_module_css__WEBPACK_IMPORTED_MODULE_2___default().positive) : (_TrendArrow_module_css__WEBPACK_IMPORTED_MODULE_2___default().negative)),
        width: "10",
        height: "10",
        viewBox: "0 0 20 20",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0",
                y: "0",
                width: "20",
                height: "20"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.415,17.101l-1.487,-1.568l8.705,-9.187l-4.745,-0.003l-0.002,-2.057l8.18,0.007l0.006,8.632l-1.949,-0.002l-0.003,-5.008l-8.705,9.186Z",
                style: {
                    transformOrigin: "10px 10px",
                    transform: "rotate(".concat(positive ? "0deg" : "90deg", ")")
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TrendArrow);


/***/ }),

/***/ 1835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);




const AppLayout = (param)=>{
    let { title , children , robots  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    robots && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: robots
                    })
                ]
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: "https://www.fuw.ch/_static/dnd_iframe_autofit_child.js",
                strategy: "beforeInteractive"
            })
        ]
    });
};
if (true) {
    // Dark Mode, Step 1:
    // we are checking/setting system dark mode by ourselves (this must be before step 2!)
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        if (document.body) {
            document.body.classList.add("dark");
        }
    }
    // Dark Mode, Step 2:
    // registering message events from Disco
    window.addEventListener("message", (event)=>{
        if (event.origin.indexOf("fuw.ch") !== -1 && event.data.type === "colorMode") {
            if (event.data.mode === "dark") {
                document.body.classList.add("dark");
            } else {
                document.body.classList.remove("dark");
            }
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AppLayout);


/***/ }),

/***/ 4717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ stock_prices_table; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/layout/AppLayout.tsx
var AppLayout = __webpack_require__(1835);
// EXTERNAL MODULE: ./src/components/dataDisplay/stockPricesTable/StockPricesTable.module.css
var StockPricesTable_module = __webpack_require__(6108);
var StockPricesTable_module_default = /*#__PURE__*/__webpack_require__.n(StockPricesTable_module);
// EXTERNAL MODULE: ./src/components/general/icons/arrow/Arrow.tsx
var Arrow = __webpack_require__(944);
// EXTERNAL MODULE: ./src/utils/time.tsx
var time = __webpack_require__(6972);
// EXTERNAL MODULE: ./src/components/general/icons/trendArrow/TrendArrow.tsx
var TrendArrow = __webpack_require__(9406);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/layout/container/Container.module.css
var Container_module = __webpack_require__(7896);
var Container_module_default = /*#__PURE__*/__webpack_require__.n(Container_module);
;// CONCATENATED MODULE: ./src/components/layout/container/Container.tsx



const Container = (param)=>/*#__PURE__*/ {
    let { title , children  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: (Container_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Container_module_default()).title,
                children: title
            }),
            children
        ]
    });
};
/* harmony default export */ var container_Container = (Container);

// EXTERNAL MODULE: ./src/components/dataDisplay/table/Table.tsx
var Table = __webpack_require__(5609);
;// CONCATENATED MODULE: ./src/components/dataDisplay/stockPricesTable/StockPricesTable.tsx








const StockPricesTable = (param)=>{
    let { quotesResponse  } = param;
    var _quotesResponse_Values;
    const quotes = (_quotesResponse_Values = quotesResponse.Values) !== null && _quotesResponse_Values !== void 0 ? _quotesResponse_Values : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container_Container, {
        title: "Die B\xf6rse im \xdcberblick",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* Table */.iA, {
            className: (StockPricesTable_module_default()).customTable,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableBody */.RM, {
                children: quotes.map((quote, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* TableRow */.SC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* TableCell */.pj, {
                                className: (StockPricesTable_module_default()).tableGrp,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (StockPricesTable_module_default()).name,
                                        children: quote.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (StockPricesTable_module_default()).date,
                                        children: (0,time/* isToday */.zk)(new Date(quote.currentPriceDate)) ? quote.currentPriceDateFormattedSecs.split(" ")[0].split(":").slice(0, 2).join(":") : quote.currentPriceDateSoloFormatted
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                                className: (StockPricesTable_module_default()).price,
                                children: quote.currentPriceFormatted
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                                className: "".concat((StockPricesTable_module_default()).priceArrow, " ").concat(quote.dailyChangeRelFormatted[0] === "+" ? (StockPricesTable_module_default()).positive : (StockPricesTable_module_default()).negative),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendArrow/* default */.Z, {
                                    positive: quote.dailyChangeRelFormatted[0] === "+"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                                className: "".concat((StockPricesTable_module_default()).dailyChange, " ").concat(quote.dailyChangeRelFormatted[0] === "+" ? (StockPricesTable_module_default()).positive : (StockPricesTable_module_default()).negative),
                                children: quote.dailyChangeRelFormatted
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* TableCell */.pj, {
                                className: (StockPricesTable_module_default()).arrow,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://wp.fuw.ch".concat(quote.fuwUrl),
                                    target: "_parent",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow/* default */.Z, {
                                        rotation: 270
                                    })
                                })
                            })
                        ]
                    }, i))
            })
        })
    });
};
/* harmony default export */ var stockPricesTable_StockPricesTable = (StockPricesTable);

;// CONCATENATED MODULE: ./src/pages/embed/stock-prices-table.tsx



const StockPricesTablePage = (param)=>{
    let { quotesResponse  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
        title: "Stock Prices Table",
        robots: "noindex,nofollow",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stockPricesTable_StockPricesTable, {
            quotesResponse: quotesResponse
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var stock_prices_table = (StockPricesTablePage);


/***/ }),

/***/ 6972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gg": function() { return /* binding */ convertTimestampToDate; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "zk": function() { return /* binding */ isToday; }
/* harmony export */ });
/* unused harmony export convertUTCToFuWTime */
function isToday(date) {
    const today = new Date();
    return date.getDate() == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear();
}
function convertUTCToFuWTime(IsoStringUTC) {
    const d = new Date(IsoStringUTC);
    const tzo = -d.getTimezoneOffset();
    const dif = tzo >= 0 ? "+" : "-";
    const pad = (num)=>{
        const norm = Math.floor(Math.abs(num));
        return (norm < 10 ? "0" : "") + norm;
    };
    return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate()) + "T" + pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds()) + dif + pad(tzo / 60) + ":" + pad(tzo % 60);
}
function convertTimestampToDate(date) {
    if (date !== undefined) {
        const dateObj = new Date(date);
        return dateObj.toLocaleDateString("de-CH", {
            hour: "2-digit",
            minute: "2-digit",
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    } else {
        return "Invalid date";
    }
}
function formatDate(timestamp) {
    let locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "de-CH";
    return new Date(timestamp).toLocaleDateString(locale, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
}



/***/ }),

/***/ 3555:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"alignLeft":"Utilities_alignLeft__MxRYq","alignRight":"Utilities_alignRight__dtYUv","negative":"Utilities_negative__LZUxg","positive":"Utilities_positive__eyzkl","hide":"Utilities_hide__HNfTN","ellipsis":"Utilities_ellipsis__MMn_A"};

/***/ }),

/***/ 6108:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tableGrp":"StockPricesTable_tableGrp__98npz","name":"StockPricesTable_name__31JRn","date":"StockPricesTable_date__sr5ip","price":"StockPricesTable_price__HmUnb","priceArrow":"StockPricesTable_priceArrow__TAlFT","dailyChange":"StockPricesTable_dailyChange__6kyJN","positive":"StockPricesTable_positive__pUz3U","negative":"StockPricesTable_negative__stvHV","arrow":"StockPricesTable_arrow__Kfval","customTable":"StockPricesTable_customTable__4uPCn"};

/***/ }),

/***/ 9838:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__xpk7y","tableHeader":"Table_tableHeader__HLcE7","tableBody":"Table_tableBody__JuauZ"};

/***/ }),

/***/ 8682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"itemArrow":"TrendArrow_itemArrow__PjLMD","positive":"TrendArrow_positive__WUhGL","negative":"TrendArrow_negative__287GI"};

/***/ }),

/***/ 7896:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__slVV4","title":"Container_title__9yjSi"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3573)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(799); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);